// 요금제 설정 (가격, 한도) 공통 모듈
// admin > 요금제 설정에서 관리되며, /api/app-settings에서 fetch (key: plan_*)

import { useEffect, useState } from "react";

const API = process.env.REACT_APP_API_URL || "";

// 기본값 (DB fetch 실패 시 fallback)
export const DEFAULT_PLAN_SETTINGS = {
  // Free
  plan_free_price_usd: "$0",
  plan_free_stl_per_day: "10",
  plan_free_ai_svg: "3",
  plan_free_storage: "50MB",

  // Standard
  plan_standard_price_usd: "$2.99",
  plan_standard_price_krw: "3,300원",
  plan_standard_stl: "unlimited",
  plan_standard_ai_svg: "100",
  plan_standard_storage: "1GB",

  // Pro
  plan_pro_price_usd: "$8.99",
  plan_pro_price_krw: "9,900원",
  plan_pro_stl: "unlimited",
  plan_pro_ai_svg: "500",
  plan_pro_storage: "5GB",
};

let cached = null;
let cachedPromise = null;

export async function fetchPlanSettings() {
  if (cached) return cached;
  if (cachedPromise) return cachedPromise;

  cachedPromise = (async () => {
    try {
      const res = await fetch(`${API}/api/app-settings`);
      const data = await res.json();
      cached = { ...DEFAULT_PLAN_SETTINGS };
      Object.keys(DEFAULT_PLAN_SETTINGS).forEach((k) => {
        if (data[k] != null && data[k] !== "") cached[k] = String(data[k]);
      });
    } catch (e) {
      cached = { ...DEFAULT_PLAN_SETTINGS };
    }
    cachedPromise = null;
    return cached;
  })();

  return cachedPromise;
}

export function usePlanSettings() {
  const [settings, setSettings] = useState(cached || DEFAULT_PLAN_SETTINGS);

  useEffect(() => {
    let mounted = true;
    fetchPlanSettings().then((s) => {
      if (mounted) setSettings(s);
    });
    return () => {
      mounted = false;
    };
  }, []);

  return settings;
}

// 키 목록 (admin 페이지에서 사용)
export const PLAN_FIELD_GROUPS = [
  {
    title: "Free 플랜",
    fields: [
      { key: "plan_free_price_usd", label: "Free 가격 (USD 표시)", placeholder: "$0" },
      { key: "plan_free_stl_per_day", label: "Free STL 다운로드 (일일)", placeholder: "10" },
      { key: "plan_free_ai_svg", label: "Free AI 디자인 (일)", placeholder: "3" },
      { key: "plan_free_storage", label: "Free 저장공간", placeholder: "50MB" },
    ],
  },
  {
    title: "Standard 플랜",
    fields: [
      { key: "plan_standard_price_usd", label: "Standard 가격 (USD)", placeholder: "$2.99" },
      { key: "plan_standard_price_krw", label: "Standard 가격 (원, 한국어 표시용)", placeholder: "3,300원" },
      { key: "plan_standard_stl", label: "Standard STL 다운로드 (unlimited 또는 숫자)", placeholder: "unlimited" },
      { key: "plan_standard_ai_svg", label: "Standard AI 디자인 (일)", placeholder: "100" },
      { key: "plan_standard_storage", label: "Standard 저장공간", placeholder: "1GB" },
    ],
  },
  {
    title: "Pro 플랜",
    fields: [
      { key: "plan_pro_price_usd", label: "Pro 가격 (USD)", placeholder: "$8.99" },
      { key: "plan_pro_price_krw", label: "Pro 가격 (원, 한국어 표시용)", placeholder: "9,900원" },
      { key: "plan_pro_stl", label: "Pro STL 다운로드 (unlimited 또는 숫자)", placeholder: "unlimited" },
      { key: "plan_pro_ai_svg", label: "Pro AI 디자인 (일)", placeholder: "500" },
      { key: "plan_pro_storage", label: "Pro 저장공간", placeholder: "5GB" },
    ],
  },
];
